import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function parameterService() {
  function getParameter(code) {
    return http.get('/v1/parameters', { params: { code }, ...OPTIONS_INTEGRATION })
  }

  return { getParameter }
}
